const trimTrailingSlash = (value = '') => value.replace(/\/+$/, '');
const addLeadingSlash = (value = '') => value.startsWith('/') ? value : `/${value}`;

export const API_BASE_URL = trimTrailingSlash(process.env.VUE_APP_API_BASE_URL || '');
export const SEARCH_API_BASE_URL = trimTrailingSlash(process.env.VUE_APP_SEARCH_API_BASE_URL || '');
export const PPT_BASE_URL = trimTrailingSlash(process.env.VUE_APP_PPT_BASE_URL || 'https://ppt.perspcloud.com');

export function getApiUrl (path = '') {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  return `${API_BASE_URL}${addLeadingSlash(path)}`;
}

export function getSearchApiUrl (path = '') {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  return `${SEARCH_API_BASE_URL}${addLeadingSlash(path)}`;
}
